import React, { useEffect, useState } from "react";
import logoIcon1 from "../../Assets/About/wwp_img1.svg";
import axios from 'axios'

const WhatWeProvideHome = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAllServices = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/services/getAllServiceByBranchId/674586f39aa6780fb2688685`,
      headers: {}
    };

    axios.request(config)
      .then((response) => {
        setData(response.data);
        setLoading(false); // Stop loading after data is fetched
      })
      .catch((error) => {
        console.log(error);
        setLoading(false); // Stop loading if there is an error
      });
  }

  useEffect(() => {
    getAllServices();
  }, []);

  const handleBookNow = (service) => {
    const phoneNumber = '917327986868'; // Replace with your phone number including country code
    const message = `Hello, I would like to book the service: ${service?.name}. Price: ₹ ${service?.price} for ${service?.duration} minutes.`;

    // URL encode the message to make sure it's formatted correctly
    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp with pre-filled message
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open the WhatsApp chat
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="bg-[#FFEFEA] p-8 md:p-16 flex gap-6 flex-col items-center">
      <h2 className="text-[#202020] font-serif text-center font-extrabold text-3xl md:text-5xl" data-aos="fade-right">
        What We Provide
      </h2>
      <p className="poppins-thin tracking-wide leading-6 lg:w-[80%] font-[500] text-[#5F5F5F] text-base md:text-lg capitalize text-center w-full" data-aos="fade-left">
        Discover a world of tranquility, luxury, and personalized care as you
        embark on a journey of self-care and renewal. Visit us today and let us
        transport you to a realm of beauty and serenity.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 w-full">
        {loading ? (
          // Display skeleton loaders while data is loading
          Array.from({ length: 3 }).map((_, index) => <SkeletonCard key={index} />)
        ) : (
          // Display data when it is loaded
          data?.map((item) => <Card item={item} key={item.id} handleBookNow={handleBookNow} />)
        )}
      </div>
    </div>
  );
};

export default WhatWeProvideHome;

// Skeleton loader card component
function SkeletonCard() {
  return (
    <div className="flex flex-col items-center justify-center bg-white rounded-md space-y-4 py-4 md:py-8 md:gap-4 px-2 animate-pulse">
      <div className="w-16 h-16 bg-gray-300 rounded-full mx-auto"></div>
      <div className="w-3/4 h-6 bg-gray-300 rounded mb-2 mx-auto"></div>
      <div className="w-4/5 h-4 bg-gray-300 rounded mb-4 mx-auto"></div>
      <div className="w-72 h-48 bg-gray-300 rounded mx-auto"></div>
    </div>
  );
}

// Card component to display actual data
function Card({ item, handleBookNow }) {
  return (
    <div className="flex flex-col items-center justify-center bg-white rounded-md space-y-4 py-4 md:py-8 md:gap-4 px-2" data-aos={item.animation}>
      <img className="object-cover mx-auto" src={logoIcon1} alt='img' />
      <div className="md:px-4">
        <h2 className="text-2xl font-bold tracking-wide font-serif text-center mb-2">
          {item.name}
        </h2>
        <p className="text-[#8A8A8A] mx-2 poppins-thin leading-6 tracking-wide md:text-lg text-base text-center capitalize">
          {item.description}
        </p>
      </div>
      <img className="object-cover mx-auto h-[15rem] px-2" src={item.image} alt={item.title} />
      <div className="flex justify-center mt-4">
        <button
          onClick={() => handleBookNow(item)}
          className="tracking-wide bg-[#ff6a00] text-white font-bold py-2 px-4 rounded">
          Book Now
        </button>
      </div>
    </div>
  );
}
